export default __webpack_public_path__ + "static/media/fraud-protection.0e937107.svg";